import { render } from "./publication.vue?vue&type=template&id=9e3efb96&scoped=true"
import script from "./publication.vue?vue&type=script&lang=js"
export * from "./publication.vue?vue&type=script&lang=js"

import "./publication.vue?vue&type=style&index=0&id=9e3efb96&scoped=true&lang=css"

import exportComponent from "D:\\Project\\2022\\management-system\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3efb96"]])

export default __exports__